const map = {
	"./shared/benchmarks/benchmark-percentile-chart/index.js": [
		45084,
		[
			2528,
			7326,
			2316,
			5084
		]
	],
	"./shared/benchmarks/benchmarks-list/index.js": [
		93898,
		[
			9945,
			2528,
			2316,
			3898
		]
	],
	"./shared/benchmarks/benchmarks-selector/index.js": [
		94264,
		[
			2528,
			7326,
			2316,
			7621,
			4264
		]
	],
	"./shared/benchmarks/config/index.js": [
		21297,
		[
			7326,
			1297
		]
	],
	"./shared/benchmarks/hooks/index.js": [
		50687,
		[
			687
		]
	],
	"./shared/benchmarks/screens/index.js": [
		13740,
		[
			7326,
			3740
		]
	],
	"./shared/benchmarks/simple-store/index.js": [
		58181,
		[
			8181
		]
	],
	"./shared/copy-to-clipboard/index.js": [
		71237,
		[
			2316,
			1237
		]
	],
	"./views/index.js": [
		85653,
		[]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return Promise.all(ids[1].map((id) => (__webpack_require__.e(id)))).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 86864;
module.exports = webpackAsyncContext;